import oGet from 'lodash/get'
import { Config, IS_PRO } from './config'
import { rules } from './rule'
import Compressor from 'compressorjs'

const noop = (): void => void 0

const fixPhoneNumber = (number: string) => {
  const rs = number.match(/\(([^)]*)\)/)
  if (rs) {
    return rs[1]
  }
  return number
}

const checkPhoneNumber = (number: string) => {
  return rules.phoneNumber.test(number)
}

//正式站不打印
export const deleteConsole = () => {
  if (IS_PRO) {
    console.log = noop
    console.warn = noop
  }
}

// 本地验证密码有效性
const checkPassword = (password: string) => {
  // 目前是任意数 6 位以上
  return /^[\s\S]{6,}$/.test(password)
}

const checkUploadFile = (file: { type: string; size: number }) => {
  const supportFileTypes = [
    'image/jpeg',
    'image/png',
    'image/jpg',
    'image/tiff',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
  ]
  const supportFileSize = Config.Fax.SendFileSize

  // type check
  if (!supportFileTypes.includes(file.type)) {
    return 'The file format is not supported.'
  }

  // size check
  const fileSize = file.size / 1024 / 1024 // M
  if (fileSize > supportFileSize) {
    return `The uploaded file shouldn't exceed ${supportFileSize}M!`
  }
  return
}

//处理图片 (传进来的是img)
const handleAndCheckUploadImg = (file: { type: string; size: number; name: string }) => {
  return new Promise((re, ej) => {
    //@ts-ignore
    new Compressor(file, {
      // https://github.com/fengyuanchen/compressorjs
      quality: 0.6,
      maxHeight: 1754,
      maxWidth: 1754,
      success(result: Blob) {
        // size check
        const transFile = new File([result], file.name, { type: file.type })
        const fileSize = transFile.size / 1024 / 1024 // M
        const supportImgFileSize = Config.Fax.SendImgFileSize
        //图片不超过2M
        if (fileSize > supportImgFileSize) {
          ej(`The uploaded img shouldn't exceed ${supportImgFileSize}M!`)
        }
        re(transFile)
      },
      error(err) {
        re(file)
      },
    })
  })
}

const oGets = (obj: any, keys: string[] = []) => {
  return keys.map((key) => oGet(obj, key))
}

const getUUID = function getUUID(len: number = 18) {
  const str = []
  const Chars = '0123456789abcdefghijklmnopqrstuvwxyz'
  for (var i = 0; i < len; i++) {
    if (i !== 0 && i % 6 === 0) {
      str[i] = '-'
    } else {
      str[i] = Chars.substr(Math.floor(Math.random() * 16), 1)
    }
  }
  return str.join('')
}

export const getQueryString = (name: string) => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURIComponent(r[2])
  }
  return ''
}

const isValidKey = (key: string | number | symbol, object: object): key is keyof typeof object => {
  return key in object
}

export {
  oGets,
  noop,
  checkUploadFile,
  handleAndCheckUploadImg,
  fixPhoneNumber,
  checkPhoneNumber,
  checkPassword,
  getUUID,
  isValidKey,
}
